//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  archiveItems,
  unarchiveItems,
  deleteItem,
} from "../db-utils.js";
import {removeFromAllLayouts} from '../utils.js'

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      backdropEl: null,
    };
  },
  methods: {
    editName() {
      const name = prompt(
        this.$gettext("New name:"),
        this.item.name,
      )
      if (name) this.item.clone({name}).save();
    },
    archive() {
      archiveItems([this.item], this);
      removeFromAllLayouts(this.item._id, this.$reactiveCache);
    },
    unarchive() {
      unarchiveItems([this.item]);
    },
    deleteList() {
      const parentClass = this.item._id.split(':')[0]
      const children = this.item.getChildren();
      if (!children.length) {
        deleteItem(this.item, this.$reactiveCache);
        removeFromAllLayouts(this.item._id, this.$reactiveCache);
      } else {
        alert(
          `This ${parentClass} still has ${children.length} item(s) inside! `
          + "(Some may be hidden.)\nCannot delete."
        )
      }
    },
    shareItem() {
      this.$root.$emit("share-dialog", {
        item: this.item,
        dbs: this.$sessionState.dbs,
      });
    },
    showBackdrop() {
      if (!this.backdropEl) {
        this.backdropEl = document.createElement("div");
        this.backdropEl.classList.add("menu-backdrop");
        document.body.appendChild(this.backdropEl);
      }
    },
    removeBackdrop() {
      if (this.backdropEl) {
        this.backdropEl.remove();
        this.backdropEl = null;
      }
    },
  },
  beforeDestroy() {
    this.removeBackdrop();
  },
};
